var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1490_467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16663 0H1.16663C0.523315 0 0 0.523315 0 1.16663V4.16663C0 4.81006 0.523315 5.33337 1.16663 5.33337H6.16663C6.81006 5.33337 7.33337 4.81006 7.33337 4.16663V1.16663C7.33337 0.523315 6.81006 0 6.16663 0Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16663 6.66797H1.16663C0.523315 6.66797 0 7.19128 0 7.83472V14.8347C0 15.478 0.523315 16.0013 1.16663 16.0013H6.16663C6.81006 16.0013 7.33337 15.478 7.33337 14.8347V7.83472C7.33337 7.19128 6.81006 6.66797 6.16663 6.66797Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8337 10.668H9.83374C9.19031 10.668 8.66699 11.1913 8.66699 11.8347V14.8347C8.66699 15.478 9.19031 16.0013 9.83374 16.0013H14.8337C15.4771 16.0013 16.0004 15.478 16.0004 14.8347V11.8347C16.0004 11.1913 15.4771 10.668 14.8337 10.668Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8337 0H9.83374C9.19031 0 8.66699 0.523315 8.66699 1.16663V8.16663C8.66699 8.81006 9.19031 9.33337 9.83374 9.33337H14.8337C15.4771 9.33337 16.0004 8.81006 16.0004 8.16663V1.16663C16.0004 0.523315 15.4771 0 14.8337 0Z",
    fill: "#636363"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1490_467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard .daf20493ad8e836abee13e1e2669806d.svg";
export { ForwardRef as ReactComponent };